import { render, staticRenderFns } from "./PersonGraph.vue?vue&type=template&id=52cd02e4&"
import script from "./PersonGraph.vue?vue&type=script&lang=js&"
export * from "./PersonGraph.vue?vue&type=script&lang=js&"
import style0 from "./PersonGraph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports